const convertIsoDatetimeToDate = (datetime) => {
  let d = new Date(datetime);
  return d.getUTCDate() + '.' + (d.getUTCMonth() + 1) + '.' + d.getUTCFullYear();
};

export default convertIsoDatetimeToDate;